import { render } from "./ChangePasswordComponent.vue?vue&type=template&id=1ca0f7d2"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/changePassword/ChangePasswordComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ca0f7d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ca0f7d2', __exports__)) {
    api.reload('1ca0f7d2', __exports__)
  }
  
  module.hot.accept("./ChangePasswordComponent.vue?vue&type=template&id=1ca0f7d2", () => {
    api.rerender('1ca0f7d2', render)
  })

}


export default __exports__